<ng-container *transloco="let t;">
  <app-list-view [title]="t('common.labels.users')" [messages]="messages" [loading]="loading">

    <div buttons>
      <button withRight="admin.user.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
      <button withRight="admin.user.create" pButton (click)="onNew()" type="button" icon="pi pi-plus" label="{{ t('common.labels.new') }}" class="p-button-success p-ml-2 p-mb-2"></button>
    </div>

    <div table>
      <p-table
        [value]="users"
        [paginator]="true"
        [rows]="20"
        stateStorage="local"
        stateKey="user-list"
        [rowsPerPageOptions]="rowsPerPage"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="t('common.labels.current_page_report')"
      >
        <ng-template pTemplate="colgroup">
          <colgroup>
              <col style="width:20%">
              <col style="width:20%">
              <col style="width:40%">
              <col style="width:20%">
          </colgroup>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
              <th pSortableColumn="firstname" aria-label="{{ t('common.labels.name') }}">{{ t('common.labels.firstname') }}
                  <p-sortIcon field="firstname"></p-sortIcon>
              </th>
              <th pSortableColumn="lastname">{{ t('common.labels.lastname') }}
                  <p-sortIcon field="lastname"></p-sortIcon>
              </th>
              <th pSortableColumn="email">{{ t('common.labels.email') }}
                  <p-sortIcon field="email"></p-sortIcon>
              </th>
              <th>{{ t('common.labels.roles') }}</th>
          </tr>
          <tr class="filter">
            <th>
              <p-columnFilter type="text" field="firstname" [matchMode]="'contains'"></p-columnFilter>
            </th>
            <th>
              <p-columnFilter type="text" field="lastname" [matchMode]="'contains'"></p-columnFilter>
            </th>
            <th>
              <p-columnFilter type="text" field="email" [matchMode]="'contains'"></p-columnFilter>
            </th>
            <th>
              <p-columnFilter type="text" field="rolenamelist" [matchMode]="'contains'"></p-columnFilter>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user>
            <tr (click)="onOpen(user)" (keyup.enter)="onOpen(user)" hoverOnRight="admin.user.show" tabindex="0">
              <td><span role="link" [attr.aria-label]="user.fullname">{{ user.firstname }}</span></td>
              <td>{{ user.lastname }}</td>
              <td>{{ user.email }}</td>
              <td>{{ user.translated_rolenames.join(', ') }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="4">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </app-list-view>
</ng-container>
